import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router , NavigationEnd, ActivatedRoute } from '@angular/router';
import { PagestateService } from '../pagestate.service';
import { filter } from 'rxjs/operators';
// import Swal from 'sweetalert2/dist/sweetalert2.js';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import swal from 'sweetalert2';
import { CommonService } from '../common.service';
import { AdminRightServiceService } from '../shared/admin.rights.service';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidenavComponent implements OnInit {
  isExpanded:boolean=true;
  showSubSubMenuPayment:boolean =false;
  rentalVehicleSubMenu:boolean = false
  geofenceSubMenu:boolean = false
  ridesSubMenu: boolean = false;
name:any;

  constructor(private router: Router, private adminRules:AdminRightServiceService
    ,   public pageStateService:PagestateService,private route: ActivatedRoute,private common:CommonService) { }

  ngOnInit(): void {
    // this.router.events
    // .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    // .subscribe((e: NavigationEnd) => {
    //   this.pageStateService.setActivePage(this.getPageFromUrl(e.urlAfterRedirects));
    // });
    this. name = localStorage.getItem('name');
    this.name =this. name?.replace(/^"(.*)"$/, '$1');
  }
  showSubSubmenupayment() {
    this.showSubSubMenuPayment = !this.showSubSubMenuPayment
    if (this.showSubSubMenuPayment == true) {


    }
  }

  showRentalVehicleSubMenu() {
    this.rentalVehicleSubMenu = !this.rentalVehicleSubMenu
  }

  showGeofenceSubMenu() {
    this.geofenceSubMenu = !this.geofenceSubMenu
  }

  showRidesSubMenu() {
    this.ridesSubMenu = !this.ridesSubMenu;
  }

  getPageFromUrl(url: string): string {
    // Extract the page from the URL
    const page = url.split('/').pop();
    return page || '';
  }

  isPageActive(page: string): boolean {
    const currentUrl = this.router.url;
    const currentPage = currentUrl.split('/')[1]; // Extract the current page from the URL
    return currentPage === page;
  }
  navigateTo(page: string): void {
    this.pageStateService.setActivePage(page);
    this.router.navigate(['/main', page]);
  }
  scrollto(){
    window.scrollTo(0,0);
  }
  // confirmBox() {
  //   swal({

  //     title: '',
  //     text: 'Are you sure, you want to logout ? ',
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     cancelButtonText: 'No',
  //     confirmButtonText: 'Yes',
  //     allowOutsideClick: false
  //   }).then(() => {
  //     localStorage.clear();
  //     this.router.navigate(['/login']);

  //   }, () => {

  //   })
  // }
  confirmBox(){
    Swal({
      position: 'top-end',
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(() => {
      localStorage.clear();
          this.router.navigate(['/login']);
        },
      ()=> {
      })
    }

    changeSideNavState(): void {
      this.common.changeSideNavState();
    }
    hasNoAuthorityForModule(module:any){
      return this.adminRules.hasNoAuthorityForModule(module);
    }
  }
